<section [style]="styles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }

  @let isDateReadonly = isReadOnly() || isReadOnlyDate();
  @let isTimeReadonly = isReadOnly() || isReadOnlyTime();

  <div class="input-container" [style]="inputsContainerStyles">
    @if (dateFieldEnabled) {
      <div
        class="input date"
        [class.validation-error]="hasValidationError"
        [class.readonly]="isDateReadonly"
        [style]="dateWrapperStyles"
      >
        @if (isDatepickerDisabled) {
          <input
            type="text"
            class="input-control"
            [placeholder]="maskedDateInputPlaceholder"
            [formControl]="maskedDateInputCtrl"
            [style]="inputStyles"
            blazeInputMask
            predefinedMask="datetimeInputMask"
            spellcheck="false"
            [maskOptions]="{ dateFormat: currentDateFormat }"
            (input)="onMaskedDateInput($event)"
            data-cy="DateTimeInputElement:maskedInput"
          />
        } @else {
          <input
            #dateInput
            type="text"
            class="input-control"
            [placeholder]="props?.content?.date?.placeholder ?? props?.content?.date?.format"
            [formControl]="dateInputCtrl"
            [matDatepicker]="datepicker"
            [style]="inputStyles"
            [min]="minDate"
            [max]="maxDate"
            spellcheck="false"
            data-cy="DateTimeInputElement:datepickerInput"
            (click)="openDatepicker()"
            [autoSlashDateInput]="currentDateFormat"
            (input)="onInput($event)"
            (dateChange)="onDatepickerInputChange($event)"
          />
          <mat-datepicker
            #datepicker
            panelClass="bl-datepicker with-theme"
            [startView]="'month'"
            [touchUi]="false"
            [restoreFocus]="true"
            [calendarHeaderComponent]="datepickerHeader"
          />
        }
        @if (dateInputCtrl.value && !isDateReadonly) {
          <button
            class="clear-date with-theme"
            data-cy="DateTimeInput:clearDate"
            (click)="clearDateInput()"
          >
            <mat-icon svgIcon="close" />
          </button>
        }
      </div>
    }
    @if (timeFieldEnabled) {
      <div
        #timeOrigin="blazeAutocompleteOrigin"
        blazeAutocompleteOrigin
        class="input time"
        [class.validation-error]="hasValidationError"
        [class.time-only]="!dateFieldEnabled && timeFieldEnabled"
        [class.readonly]="isTimeReadonly"
        [style]="timeWrapperStyles"
      >
        <input
          #timeInput
          type="text"
          class="input-control"
          [style]="inputStyles"
          [placeholder]="timePlaceholder"
          [formControl]="timeInputCtrl"
          spellcheck="false"
          [blazeAutocomplete]="autocomplete"
          [blazeAutocompleteConnectedTo]="timeOrigin"
          (beforeinput)="timeInputTransform($event, timeInputCtrl)"
          (paste)="timeInputPaste($event, timeInputCtrl)"
          (focus)="openTimePicker()"
          (blur)="timeInputBlur($event, timeInputCtrl)"
        />
        <div class="flex items-center" id="time-suffix-button">
          @if (timeSuffix) {
            <button class="time-suffix" (click)="changeTimeSuffix()" [style]="inputStyles">
              {{ timeSuffix }}
            </button>
          }
        </div>
        <blaze-autocomplete
          class="inline-editor-time-picker with-theme w-[400px]"
          #autocomplete="blazeAutocomplete"
          (opened)="onAutocompleteOpen()"
        >
          @let timeProposalArray = (timeProposalArray$ | async) ?? [];

          <div class="blaze-autocomplete-content">
            <blaze-scroller overflowX="hidden">
              @for (timeProposal of timeProposalArray; track timeProposal) {
                <button
                  class="min-w-[90px] blaze-option"
                  [class.selected]="pickedTimeForSelectedMarker === timeProposal"
                  type="button"
                  [blazeAutocompleteOption]="timeProposal"
                >
                  {{ timeProposal }}
                </button>
              }
            </blaze-scroller>
          </div>
        </blaze-autocomplete>
      </div>
    }
  </div>
</section>

@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{
      formState?.messages?.required ||
        formState?.messages?.endAfterStart ||
        formState?.messages?.invalid ||
        ''
    }}
  </div>
}
